import { put } from 'redux-saga/effects';
import api from '../../helpers/api';
import { getCompanyFromWebSessionStorage } from '../../helpers/session';
import { selectToken, selectUserId } from '../selectors';
import { store } from '../store';
import * as actions from './actions';

export function* getItemsRequestSaga(payload) {
  try {
    const _store = store.getState();
    const userId = selectUserId(_store);
    const companyId = getCompanyFromWebSessionStorage()?.id;
    const res = yield api.send({
      url: '/items',
      method: 'GET',
      token: selectToken(_store),
      params: { ...payload.data, userId, companyId },
    });
    yield put(actions.getItemsRequestSuccess({ res }));
  } catch (error) {
    yield put(actions.getItemsRequestFailure(error));
  }
}
